import React from 'react';

export const SMS_OPT_IN_CONSENT =
  'By providing your mobile number, you agree to receive transactional text messages for verification, security, and account updates. Message and data rates may apply. Reply STOP to opt out and HELP for support.';

export const SMS_OTP_CONSENT =
  'By continuing, you agree to receive transactional text messages for verification and account security.';

interface SmsConsentNoticeProps {
  variant?: 'default' | 'otp';
  className?: string;
  tone?: 'light' | 'dark';
}

const SmsConsentNotice: React.FC<SmsConsentNoticeProps> = ({
  variant = 'default',
  className = '',
  tone = 'light',
}) => {
  const text = variant === 'otp' ? SMS_OTP_CONSENT : SMS_OPT_IN_CONSENT;
  const toneClass = tone === 'dark' ? 'text-gray-400' : 'text-gray-500 dark:text-gray-400';

  return (
    <p className={`text-xs leading-5 ${toneClass} ${className}`}>
      {text}
    </p>
  );
};

export default SmsConsentNotice;
